// _shared/utils/colorUtils.js
export const getContrastColor = (hexColor) => {
    // Si no hay color, devolver blanco por defecto
    if (!hexColor) return '#ffffff';
    
    // Convertir hex a RGB
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    // Calcular luminancia (fórmula WCAG)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Si la luminancia es > 0.5, el color es claro → texto oscuro
    // Si es < 0.5, el color es oscuro → texto claro
    return luminance > 0.5 ? '#1a1a2e' : '#ffffff';
  };
  
  export const isLightColor = (hexColor) => {
    if (!hexColor) return false;
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5;
  };